module.exports = __webpack_public_path__ + "img/topic-btn.b31d2655.png";